import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../../components/table/styled-table";
import SaleItemTableRow from "./sale-items-table-row";
import { SaleItem, SaleItemRequest } from "../../../../service/model/store.model";
import { configs } from "../../../../app/app-configs";
import Alert from "@mui/material/Alert";

const headers: ColumnHeader[] = [
    { name: "Product Name" },
    { name: "Quantity" },
    { name: "Unit Cost" },
    { name: "Selling Price" },
    { name: "Total Amount" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly saleItems: SaleItem[]
    readonly editable: boolean
    readonly onEdit: (data: SaleItemRequest) => void
    readonly onDelete: (id: number) => void
}

const SaleItemTable: React.FC<TableProps> = ({saleItems, editable, onEdit, onDelete}) => {
    
    const [page, setPage] = useState(1);

    const pageCount = Math.ceil(saleItems.length / configs.PAGE_SIZE);
    
    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <>
            {!editable &&
                <Alert severity="warning">Sale items cannot be edited or deleted once the sale is completed.
                    To make changes, please cancel the sale and create a new one.</Alert>
            }
            <StyledTable headers={editable ? headers : headers.filter(h => h.name !== "Actions")}
                currentPage={page}
                totalPages={pageCount}
                onPageChange={handlePageChange}>

                {saleItems?.map(saleitem =>
                    <SaleItemTableRow editable={editable} saleItem={saleitem} key={saleitem.id} onEdit={onEdit} onDelete={onDelete} />
                )}
            </StyledTable>
        </>
    );
}

export default SaleItemTable;